import { Component } from '@angular/core';

@Component({
  selector: 'app-pdf-files-without-software',
  imports: [],
  templateUrl: './pdf-files-without-software.component.html',
  styleUrl: './pdf-files-without-software.component.css'
})
export class PdfFilesWithoutSoftwareComponent {

}
